export default function tabs({ variables }) {
    return {
        MuiTabs: {
            styleOverrides: {
                root: {
                    minHeight: "auto",
                },
                indicator: {
                    height: "2px",
                    backgroundColor: variables.interactive_selected,
                },
                list: {
                    gap: variables.spacing_03,
                },
            },
        },
        MuiTab: {
            styleOverrides: {
                root: {
                    minWidth: "auto",
                    minHeight: variables.component_height_small,
                    padding: `0 ${variables.spacing_05}`,
                    color: variables.text_medium,
                    fontSize: variables.type_body_sm_font_size,
                    textTransform: "none",
                    transition: "color ease 0.2s",
                    "&:hover": {
                        color: variables.text_primary,
                    },
                    "&.Mui-selected": {
                        color: variables.text_primary,
                        fontWeight: variables.font_weight_semibold,
                    },
                },
            },
        },
    };
}
//# sourceMappingURL=tabs.js.map